import React from 'react';
import T from 'prop-types';
import LinkList from '../Linklist';

/**
 * Will wrap a `<LinkList>` component with a `div.info-box`
 * and a `h2` heading inside `div.info-box__heading`.
 *
 */
const InfoBox = (props) => {
  const { InfoText, LinkCollection } = props;
  return (
    <div className="info-box">
      {InfoText && (
        <div className="info-box__heading">
          <h2>{InfoText}</h2>
        </div>
      )}
      {LinkCollection && <LinkList Links={LinkCollection} />}
    </div>
  );
};

InfoBox.propTypes = {
  /** Heading */
  InfoText: T.string,
  /** Will be passed as prop `Links` to `<LinkList>` component */
  LinkCollection: T.array,
};

export default InfoBox;
